import script from "./JoinPage.vue?vue&type=script&setup=true&lang=js"
export * from "./JoinPage.vue?vue&type=script&setup=true&lang=js"

import "./JoinPage.vue?vue&type=style&index=0&id=e5a68ff4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5a68ff4"]])

export default __exports__